var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.55,6.16h-69a4.54,4.54,0,0,0-4.48,4.59V41.8a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1v69.5a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V56a3.37,3.37,0,0,0-1.75-6.19A3.37,3.37,0,0,0,7.11,56v24.3a4.54,4.54,0,0,0,4.48,4.59h69A4.54,4.54,0,0,0,85,80.25V10.75A4.54,4.54,0,0,0,80.55,6.16Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m80.4,6.16H11.4c-2.47.08-4.43,2.12-4.4,4.59v31.05c-.07.96.65,1.8,1.61,1.88.96.07,1.8-.65,1.88-1.61,0-.09,0-.18,0-.26V10.8c0-.55.45-1,1-1h69c.55,0,1,.45,1,1v69.5c0,.55-.45,1-1,1H11.49c-.55,0-1-.45-1-1v-24.3c.96-.64,1.53-1.73,1.51-2.88.02-1.84-1.46-3.34-3.3-3.36,0,0,0,0,0,0-1.83.03-3.29,1.53-3.27,3.36-.01,1.17.58,2.26,1.57,2.88v24.3c-.03,2.5,1.98,4.56,4.48,4.59h69c2.5-.03,4.51-2.09,4.48-4.59V10.75c.03-2.51-1.98-4.56-4.49-4.59-.02,0-.05,0-.07,0Z",
    fill: "#006098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44.48,52.53v2.05c0,1.01-.19,2.01-.56,2.94-.38.89-.9,1.69-1.59,2.39-.67.7-1.45,1.28-2.32,1.69-.9.43-1.88.63-2.87.63-.89,0-1.79-.14-2.65-.38-.9-.24-1.72-.68-2.44-1.3-.75-.67-1.37-1.47-1.79-2.39-.51-1.18-.73-2.46-.68-3.74v-18.16c0-1.02.17-2.05.55-3,.7-1.83,2.12-3.28,3.93-4.01.96-.39,1.98-.61,3.02-.61,2-.07,3.91.73,5.27,2.2.68.73,1.21,1.59,1.55,2.53.38,1.01.58,2.08.56,3.17v1.91h-4.61v-1.62c.02-.87-.26-1.71-.77-2.41-.49-.65-1.26-1.02-2.08-.97-.9-.1-1.77.31-2.25,1.09-.41.85-.6,1.81-.56,2.76v16.86c-.03.85.19,1.69.61,2.41.49.7,1.35,1.08,2.2.97.34,0,.67-.05.97-.15.36-.12.7-.29.97-.55.29-.27.53-.61.68-.97.2-.55.29-1.13.26-1.72v-1.6h4.61l-.02-.02Z",
    fill: "#0075c9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.89,63.35V34.25H46.45V29.72H62v4.53H56.59v29.1Z",
    style: {
      fill: "#0075c9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtIcon);
export default __webpack_public_path__ + "static/media/ctIcon.f3c0ebe2.svg";
export { ForwardRef as ReactComponent };